module.exports = __webpack_public_path__ + "static/media/howItWork4.d889e119.png";